/**
 * HTML IDs for general app elements
 */
export enum AppId {
    App = 'fixnet-app-wrapper',
    Error = 'fixnet-error-wrapper',
    Loading = 'sails-loading-spinner',
    OfferSummaryCard = 'fixnet-offer-summary-card',
    CableCustomerNotification = 'cable-customer-notification',
    DiscoveryCardWrapper = 'fixnet-discovery-card-wrapper',
}

/**
 * HTML IDs for CMS content parts
 */
export enum ContentId {
    FaqAccordion = 'fixnet-faq-accordion',
    FootnoteAccordionWrapper = 'footnote-accordion-wrapper',
    FootnoteAccordion = 'footnote-accordion',
    TariffFootnoteAccordionItem = 'footnotetariff',
    DiscoveryCard = 'fixnet-discovery-card',
    IconTextBanner = 'fixnet-icon-text-banner',
}

/**
 * HTML IDs for Tariff picker elements
 */
export enum TariffCardId {
    TariffPicker = 'fixnet-tariff-picker',
    TariffBenefits = 'fixnet-dsl-change-benefits',
}

/**
 * HTML IDs for Customer card
 */
export enum CustomerCardId {
    Wrapper = 'fixnet-customer-info',
    Name = 'fixnet-customer-name',
    Number = 'fixnet-customer-number',
    City = 'fixnet-customer-city',
    StreetAndHouse = 'fixnet-customer-street',
}

/**
 * HTML IDs for all elements
 */
export type HtmlId = AppId | ContentId | TariffCardId | CustomerCardId;
